// API paths are resolved against REACT_APP_BACKEND_URL. Keep all backend routes under /api.
export const ENDPOINTS = {
  TELEGRAM_WIDGET_BOT: '/api/telegram/widget-bot',
  AUTH_TELEGRAM: '/api/auth/telegram',
  AUTH_TELEGRAM_WIDGET_LOGIN: '/api/auth/telegram/widget-login',
  AUTH_LINK_TELEGRAM_WIDGET: '/api/auth/link-telegram-widget',
  ME_COMPLETE_CREDENTIALS: '/api/me/complete-credentials',
  ME_CONFIRM_REGISTRATION: '/api/me/confirm-registration',
  AUTH_RESEND_VERIFICATION: '/api/auth/resend-verification',
  API_KEY: '/api/key',
  USER_ME: '/api/me',
  ME_LANGUAGE: '/api/me/language',
  AI_MODELS: '/api/models',
  STUDIO_MODELS: '/api/studio/models',
  STUDIO_CONVERSATIONS: '/api/studio/conversations',
  STUDIO_CONVERSATION: (id) => `/api/studio/conversations/${encodeURIComponent(id)}`,
  STUDIO_MESSAGES: (id) => `/api/studio/conversations/${encodeURIComponent(id)}/messages`,
  STUDIO_IMAGE: (id, imageId) => `/api/studio/conversations/${encodeURIComponent(id)}/images/${encodeURIComponent(imageId)}`,
  // Accepts query filters: from, to, model, group, apiKeyId, endpoint, status, page, limit
  REQUESTS: '/api/requests',
  REQUESTS_SUMMARY: '/api/requests/summary',
  REQUESTS_STATS: '/api/requests/stats',
  REQUESTS_ANALYTICS: '/api/requests/analytics',
  PAYMENTS: '/api/payment',
  PAYMENT_UPGRADE: '/api/payment/upgrade',
  PAYMENT_UPGRADE_ESTIMATE: '/api/payment/upgrade/estimate',
  PAYMENT_CURRENCIES: '/api/payment/currencies',
  PAYMENT_METHODS: '/api/payment/methods',
  TOPUP_PACKAGES: '/api/topup-packages',
  FAQ: '/api/faq',
  REFERRALS: '/api/referrals',
  REFERRALS_BONUS_HISTORY: '/api/referrals/bonus-history',
  NOTIFICATIONS_FEED: '/api/notifications/feed',
  NOTIFICATIONS_SEEN: '/api/notifications/seen',
  ME_PROMO_CODE: '/api/me/promo-code',
  ME_PROFILE: '/api/me',
  ME_PASSWORD: '/api/me/password',
  ME_2FA_SETUP: '/api/me/2fa/setup',
  ME_2FA_ENABLE: '/api/me/2fa/enable',
  ME_2FA_DISABLE: '/api/me/2fa/disable',
  AUTH_2FA: '/api/auth/2fa',
};
